import React from 'react'
import MaterialSymbol from '../material-symbol'

const School = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="school" {...props} />
))

School.displayName = 'School'

export default School
